"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getServerTimeOwf = exports.getServerTime = void 0;
var init_1 = require("./common/init");
var interface_utils_1 = require("@uip-alpha/interface-utils");
exports.getServerTime = function (config) {
    /** 自定义header以及处理的http */
    return _this.http
        .get(interface_utils_1.assign({
        url: _this._baseUrl + "/wxopen/biz/currenttime"
    }, config))
        .then(function (data) {
        return data;
    })
        .catch(function () {
        return '';
    });
};
exports.getServerTimeOwf = function (config) {
    /** 自定义header以及处理的http */
    return _this.http
        .get(interface_utils_1.assign({
        url: _this._baseUrl + "/sf-service-core-web/service/orderProcess/serverTm"
    }, config))
        .then(function (data) {
        return data && data.result;
    })
        .catch(function () {
        return '';
    });
};
exports.default = (function (config) { return function (UIP) {
    /** 前置依赖模块检测 */
    if (!interface_utils_1.beforeInit(UIP)('http'))
        return;
    var _config = __assign(__assign({}, UIP.defaultConfig), config);
    _this.http = init_1.init(_config)(UIP);
    _this._baseUrl = _config.baseUrl || '';
    UIP.checkModule('interface', 'date');
    UIP.interface.date = {
        getServerTime: exports.getServerTime.bind(_this),
        getServerTimeOwf: exports.getServerTimeOwf.bind(_this)
    };
}; });



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/interface-date/dist/index.js
// module id = Ppva
// module chunks = 1